import { LayoutModule } from '@angular/cdk/layout';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { NgxsModule } from '@ngxs/store';
import { CookieService } from 'ngx-cookie-service';

import * as LinkShortenerApiModule from '@link-shortener-api/api.module';

import * as SmartHeadApiModule from '@smarthead-api/api.module';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthModule } from './auth/auth.module';
import { MainNavComponent } from './shared/core/main-nav/main-nav.component';
import { JWTTokenInterceptor } from './shared/interceptors/jwt-token.interceptor';
import { AppState } from './shared/state/app.state';

import * as AuditLogApiConfiguration from '../../../api/audit-log/api-configuration';
import * as PredictionConfiguration from '../../../api/prediction-api/api-configuration';
import { environment } from '../environments/environment';

/**
 * Setup base url by environment for Swagger API
 */

const APIV2BaseURL = () => {
  const appConfiguration = new AuditLogApiConfiguration.ApiConfiguration();
  appConfiguration.rootUrl = `${environment.api_smarthead_v2_base_path}`;
  return appConfiguration;
};

@NgModule({
  declarations: [
    AppComponent,
    MainNavComponent
  ],
  imports: [
    // *** Angular modules ***
    BrowserModule,
    BrowserAnimationsModule,
    // *** APIs ***
    SmartHeadApiModule.ApiModule.forRoot({
      rootUrl: environment.api_smarthead_base_path
    }),
    LinkShortenerApiModule.ApiModule.forRoot({
      rootUrl: environment.api_link_shortener_base_path
    }),
    // *** 3th party ***
    LayoutModule,
    MatButtonModule,
    MatIconModule,
    MatListModule,
    MatSidenavModule,
    MatToolbarModule,
    NgxsModule.forRoot([AppState], {
      developmentMode: !environment.production
    }),
    NgxsReduxDevtoolsPluginModule.forRoot({
      disabled: environment.production
    }),
    AuthModule,
    // *** Routing module ***
    AppRoutingModule
  ],
  providers: [
    CookieService,
    { provide: AuditLogApiConfiguration.ApiConfiguration, useFactory: APIV2BaseURL },
    { provide: PredictionConfiguration.ApiConfiguration, useFactory: APIV2BaseURL },
    { provide: HTTP_INTERCEPTORS, useClass: JWTTokenInterceptor, multi: true }, // add JWT token to requests
    provideHttpClient(withInterceptorsFromDi())
  ],
  exports: [MainNavComponent],
  bootstrap: [AppComponent]
})
export class AppModule {}
